import React from "react";

import "./TitledPanel.css";

export default function TitledPanel({ title, extra, children, className = "" }) {
  const rootClass = className
    ? `TitledPanel ${className}`
    : "TitledPanel";

  return (
    <section className={rootClass}>
      {(title || extra) && (
        <header className="TitledPanel__Header">
          {title && <h2 className="TitledPanel__Title">{title}</h2>}
          {extra && <div className="TitledPanel__Extra">{extra}</div>}
        </header>
      )}
      <div className="TitledPanel__Body">{children}</div>
    </section>
  );
}
